.formHeaderContainer {
    display: flex;
    justify-content: space-between;
	align-items: center;
    margin: 10px 0px;
}